import Vue from 'vue';
const mixins = {
  methods: {
    nicheColor(nicheId) {
      const colors = {
        1: 'pink',
        2: 'purple',
        3: 'red darken-3',
        4: 'orange darken-1',
        5: 'brown',
        6: 'deep-purple',
        7: 'blue',
        8: 'amber darken-2',
        9: 'teal',
        10: 'blue-grey',
      };
      return colors[nicheId] || 'grey';
    },
    nicheName(nicheId) {
      const niche = (this.$store.state.settings.niches || []).find(
        (x) => x.id === nicheId
      );
      return niche?.name || 'unknown';
    },
    countryEmoji(countryCode) {
      return this.$store.state.settings.countries.find(
        (x) => x.code === countryCode
      )?.emoji;
    },
    countryName(countryCode) {
      if (Intl && Intl?.DisplayNames && Intl?.DisplayNames !== null) {
        const displayNames = new Intl.DisplayNames(this.$i18n.locale, {
          type: 'region',
        });
        try {
          return displayNames.of(countryCode);
        } catch (e) {}
      }
      return countryCode;
    },
    languageName(locale) {
      if (Intl && Intl?.DisplayNames && Intl?.DisplayNames !== null) {
        const displayNames = new Intl.DisplayNames(this.$i18n.locale, {
          type: 'language',
        });
        try {
          return displayNames.of(locale.replace('_', '-'));
        } catch (e) {}
      }
      return locale;
    },
  },
  computed: {
    trafficsourceItemsWithNoTrafficsource() {
      const x = this.trafficsourceItems;

      x.push({
        text: this.$t('No trafficsource'),
        value: null,
      });

      return x;
    },
    trafficsourceItems() {
      if (this.$store.state.settings.trafficsources) {
        return this.$store.state.settings.trafficsources
          .filter((x) => x.status === 'active' && !x.hidden)
          .map((x) => {
            return {
              text:
                x.id +
                ' - ' +
                x.name +
                ' (' +
                this.siteOwners[x.owner]?.name +
                ')',
              value: x.id,
            };
          });
      }
      return [];
    },
    siteOwners() {
      const x = {};
      if (this.$store.state.settings.sites) {
        for (const key in this.$store.state.settings.sites) {
          const site = this.$store.state.settings.sites[key];
          if (site.hasPermission) {
            if (!Object.prototype.hasOwnProperty.call(x, site.owner_id)) {
              x[site.owner_id] = {
                name: site.owner,
                sites: [site.id],
              };
            } else {
              x[site.owner_id].sites.push(site.id);
            }
          }
        }
      }
      return x;
    },
    siteItems() {
      if (this.$store.state.settings.sites) {
        return this.$store.state.settings.sites
          .filter((x) => x.hasPermission)
          .filter((x) => x.countries.length > 0)
          .map((x) => {
            return {
              text: (x.admin_name ?? x.name) + ' (' + x.owner + ')',
              value: x.id,
            };
          });
      }
      return [];
    },
  },
};

if (!Vue.__twizie_mixin__) {
  Vue.__twizie_mixin__ = true;
  Vue.mixin(mixins);
}
